<div class="modal-background" bdFxLayoutAlign="center start">
    <div class="projects-modal">
        <div class="header">
            <div class="title">
                Achtung
            </div>
            <div class="save">
                <bd-fa-button [name]="'times'" (click)="onCancelBtnClicked()"></bd-fa-button>
            </div>
        </div>

        <div class="body">
            Sind Sie sicher, dass Sie das Projekt löschen möchten?
        </div>

        <div class="footer">
            <button class="pr-btn" type="button" (click)="onCancelBtnClicked()">
                Nein, abbrechen
            </button>
            <button class="pr-btn active" type="button" (click)="onConfirmBtnClicked()" #focusedButton>
                Ja, löschen
            </button>
        </div>
    </div>
</div>
